module.exports = __webpack_public_path__ + "img/instructionVideo.3bd0fe87.png";